import { useEffect, useState } from 'react';
import { useAuth } from '../lib/auth-context';
import { useEnterpriseOrg } from '../context/EnterpriseOrgContext';
import {
  fetchEnterpriseWorkspaceQbrExcerpts,
  type EnterpriseWorkspaceQbrExcerptsResponse,
} from '../lib/enterprise-api';
import { isEnterpriseQbrWorkspaceExcerptsEnabled } from '../lib/feature-flags';

export function useEnterpriseWorkspaceQbrExcerpts() {
  const { accessToken } = useAuth();
  const { activeOrgId, hasActiveOrgAccess } = useEnterpriseOrg();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [data, setData] = useState<EnterpriseWorkspaceQbrExcerptsResponse | null>(null);
  const flagOn = isEnterpriseQbrWorkspaceExcerptsEnabled();

  useEffect(() => {
    let cancelled = false;
    if (!flagOn || !accessToken || !activeOrgId || !hasActiveOrgAccess) {
      setData(null);
      setError(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    void fetchEnterpriseWorkspaceQbrExcerpts(accessToken, activeOrgId).then((res) => {
      if (cancelled) return;
      if (!res.success || !res.data) {
        setData(null);
        setError(res.error || 'QBR excerpts unavailable');
        setLoading(false);
        return;
      }
      setData(res.data);
      setError(null);
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, [flagOn, accessToken, activeOrgId, hasActiveOrgAccess]);

  return { loading, error, data, featureEnabled: flagOn };
}
